import styled from '@emotion/styled';

const FormWrapper = styled('section')({
  marginBottom: 8,
  display: 'flex',
  alignItems: 'center',
});

export default FormWrapper;
